import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  DataLoadStatusRoute,
  DataLoadStatusPathName,
  DataLoadTabValues,
} from '@/modules/ta/dataloadstatus/dataloadstatus.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${DataLoadStatusRoute.DATALOADSTATUS}`,
      redirect: `/${DataLoadStatusRoute.DATALOADSTATUS}/tab/${DataLoadTabValues.NEEDS_ATTENTION}`,
    },
    {
      path: `/${DataLoadStatusRoute.DATALOADSTATUS}/tab/:tabName?`,
      name: DataLoadStatusPathName.DATALOADSTATUS,
      component: () =>
        import(/* webpackChunkName: "dataloadstatus-page" */ './pages/DataLoadStatusPage.vue'),
    },
    {
      path: `/${DataLoadStatusRoute.DATALOADSTATUS}/tab/notificationrules/new`,
      name: `/${DataLoadStatusPathName.DATALOADSTATUS_NOTIFICATIONS}:new`,
      component: () =>
        import(
          /* webpackChunkName: "dataloadnotification-form-page" */ './pages/DataLoadNotificationFormPage.vue'
        ),
    },
    {
      path: `/${DataLoadStatusRoute.DATALOADSTATUS_NOTIFICATIONS}/:id`,
      name: DataLoadStatusPathName.DATALOADSTATUS_NOTIFICATIONS,
      component: () =>
        import(
          /* webpackChunkName: "dataloadnotification-form-page" */ './pages/DataLoadNotificationFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.DATALOADSTATUS
);
